import _ from "lodash"
import React, { useEffect, useState } from "react"
import { animateScroll as scroll, scroller, Element } from "react-scroll"
import { checkIfDuplicatesInArray } from "../../../util"
import MatchfitQuestionElement from "./MatchfitQuestionElement"
import BottomCtaNavigation from "../../Common/BottomCtaNavigation"

function FormSection({
  currentSection,
  form,
  isLivelife,
  lastPage,
  onChangeHandler,
  onInputChangeHandler,
  onSubmit,
  groupName,
  questionSet,
  setCurrentSection,
  title,
  description,
}) {
  const [subform, setSubform] = useState([])
  const [inflight, setInflight] = useState(false)
  const [userInputDetected, setUserInputDetected] = useState(false)
  const [showWarning, setShowWarning] = useState(false)
  const surveyType = isLivelife ? "livelife" : "matchfit"
  const {
    compulsory_question_slugs: compulsoryQuestionSlugs,
    input_question_slugs: inputQuestionSlugs,
    questions,
    section_title: sectionTitle,
  } = questionSet

  const onNextStep = () => {
    if (showWarning || userInputDetected) {
      setCurrentSection(currentSection + 1)
    } else {
      setShowWarning(true)
    }
  }

  const onPreviousStep = () => {
    setCurrentSection(currentSection - 1)
  }

  // Offset so the target question clears the sticky header (tune to header height).
  const SCROLL_OFFSET = -120

  // OnClick handler for the answers
  const onCheckHandler = e => {
    const { name, id } = e.target
    const formCopy = [...subform]
    formCopy[name] = { answer_id: id }
    setSubform(formCopy)
    onChangeHandler(e)

    // Scroll to the NEXT question's actual position rather than a fixed pixel
    // jump — self-adjusts to any card height / viewport, so it can't overshoot
    // (skip a question) or undershoot (move half a page). `name` is the answered
    // question's slug (Answer button name={formIndex}); find the following one.
    const answeredIndex = questions.findIndex(q => q.question_slug === name)
    const nextQuestion = answeredIndex !== -1 && questions[answeredIndex + 1]
    if (nextQuestion) {
      scroller.scrollTo(`question-${nextQuestion.question_slug}`, {
        duration: 500,
        smooth: "easeInOutQuad",
        offset: SCROLL_OFFSET,
      })
    }
  }

  useEffect(() => {
    if (currentSection === questionSet.page_index) {
      // If all questions on this page are Likert, then Warning is skipped
      if (!inputQuestionSlugs.length) {
        setUserInputDetected(true)
      } else if (sectionTitle === "Smoking" && _.get(form, "tobacco_yes_no.answer_slug") === "tobacco_yes_no_1") {
        setUserInputDetected(true)
      } else if (sectionTitle === "Strength" && _.get(form, "pushups_yes_no.answer_slug") === "pushups_yes_no_1") {
        setUserInputDetected(true)
      } else if (sectionTitle === "Activity Monitor" && _.get(form, "wears_activity_monitor.answer_slug") === "wears_activity_monitor_1") {
        setUserInputDetected(true)
      // If any input questions on this page are answered, then Warning is skipped
      } else if (checkIfDuplicatesInArray([...Object.keys(form), ...inputQuestionSlugs])) {
        setUserInputDetected(true)
      } else {
        setUserInputDetected(false)
      }
    } else {
      setShowWarning(false)
    }
  }, [currentSection, form, inputQuestionSlugs, questionSet.page_index, sectionTitle])

  useEffect(() => {
    if (currentSection === questionSet.page_index) {
      scroll.scrollToTop()
    }
  }, [currentSection, questionSet.page_index])

  const onClickSubmit = e => {
    if (showWarning || userInputDetected) {
      setInflight(true)
      Promise.resolve(onSubmit(e))
        .catch(() => {})
        .finally(() => setInflight(false))
    } else {
      setShowWarning(true)
    }
  }

  const handleInputChange = e => {
    setUserInputDetected(true)
    onInputChangeHandler(e)
  }

  let hasFormErrors = false
  if (form) {
    Object.keys(form).forEach(key => {
      if (form[key].errors?.length > 0) {
        hasFormErrors = true
      }
    })
  }
  // const hasFormErrors = form && Object.values(form).some(value => value?.errors?.length > 0)

  if (currentSection !== questionSet.page_index) return null
  return (
    <>
      {groupName && <h5>{groupName}</h5>}
      <h1>{title}</h1>
      <p>{description}</p>
      <hr />
      {questions.map(question => (
        <Element name={`question-${question.question_slug}`} key={`question-${question.id}`}>
          <MatchfitQuestionElement
            form={form}
            onChangeHandler={onCheckHandler}
            onInputChangeHandler={handleInputChange}
            question={question}
            selectedAnswer={form[question.question_slug]}
            surveyType={surveyType} />
        </Element>
      ))}
      {inflight ? (
        <BottomCtaNavigation
          currentSection={0}
          lastPage={0}
          inflight />
      ) : (
        <div>
          {showWarning && !userInputDetected && (
            <div className="bottom-cta mb-5 pb-3 d-flex justify-content-center bg-warning">Note: You have not answered any questions on this page. Please double check before proceeding.</div>
          )}
          <BottomCtaNavigation
            currentSection={currentSection}
            lastPage={lastPage}
            nextDisabled={hasFormErrors || _.difference(compulsoryQuestionSlugs, Object.keys(form)).length > 0}
            doneDisabled={_.difference(compulsoryQuestionSlugs, Object.keys(form)).length > 0 || inflight}
            onNextStep={onNextStep}
            onPreviousStep={onPreviousStep}
            onDone={onClickSubmit} />
        </div>
      )}
    </>
  )
}

export default FormSection